import { useCallback, useEffect, useRef, useState } from "react";

export const useOverflow = (dependencyArray: any[] = []) => {
  const ref = useRef<any>(null);
  const elementRef = useRef<any>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [isVerticalOverflowing, setIsVerticalOverflowing] = useState(false);

  const measuredRef = useCallback(
    (node: any) => {
      if (node !== null) {
        ref.current = node;
        elementRef.current = node;
        handleOverflowing(node);
        handleVerticalOverflowing(node);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...dependencyArray]
  );

  const handleOverflowing = (node?: any) => {
    const element = node || elementRef.current;
    if (element) {
      setIsOverflowing(element.scrollWidth > element.clientWidth);
    }
  };

  const handleVerticalOverflowing = (node?: any) => {
    const element = node || elementRef.current;
    if (element) {
      setIsVerticalOverflowing(element.scrollHeight > element.clientHeight + 1);
    }
  };

  useEffect(() => {
    const element = elementRef.current;

    if (typeof ResizeObserver === "undefined") return;

    if (element) {
      const resizeObserver = new ResizeObserver(() => {
        handleOverflowing();
        handleVerticalOverflowing();
      });
      resizeObserver.observe(element);
      handleOverflowing();
      handleVerticalOverflowing();
      return () => resizeObserver.disconnect();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencyArray);

  return {
    measuredRef,
    elementRef,
    isOverflowing,
    isVerticalOverflowing,
    ref
  };
};
